import { render, staticRenderFns } from "./CertificateRequirement.vue?vue&type=template&id=26bf5229&scoped=true"
import script from "./CertificateRequirement.vue?vue&type=script&lang=ts"
export * from "./CertificateRequirement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf5229",
  null
  
)

export default component.exports